import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyForgotPassword = loadable(() => import(/* webpackChunkName: "content/createwedding-forgot-password" */ './ForgotPassword'), 'ForgotPassword');
